<template>
  <div>
    <div class="down-section">
      <div id="sv" data-h-color="blck-1">
        <div id="svlg" class="lg">
          <div class="lgt fx">
            <div>
              <h3>
                <!-- <span>Skill Profiles</span> -->
                <strong>Skill Profiles</strong>
              </h3>
              <div class="tx">
                <p>
                  <strong>Skill</strong> and
                  <strong>competency</strong> discovery is the underlying
                  foundation of your career. Create a beautiful profile enriched
                  with your career skills and personality attributes that define
                  a professional persona.
                </p>
              </div>
            </div>
          </div>
          <div class="lgt fx">
            <div>
              <h3>
                <!-- <span>Some text</span> -->
                <strong>Talent Boards</strong>
              </h3>
              <div class="tx">
                <p>
                  Your boards are the talent cohorts where activities happen.
                  Activities could be career development, team building, or even
                  your first on-boarding to the company culture, everything
                  happens together with your peers on the boards.
                </p>
              </div>
            </div>
          </div>
          <div class="lgt fx">
            <div>
              <h3>
                <!-- <span>Some text</span> -->
                <strong>Power Apps</strong>
              </h3>
              <div class="tx">
                <p>
                  Apps can be added to boards to enable some particular action.
                  Simple applications like <strong>Notes</strong>,
                  <strong>Messages</strong>, <strong>Calendars</strong>, or
                  complicated ones like <strong>Career Prediction</strong>,
                  <strong>Learning Experience Manager</strong>
                  <strong>ALEX</strong>, add features to the board, enhancing it
                  to do more.
                </p>
              </div>
            </div>
          </div>
          <div class="lgt" style="padding-top: 20%">
            <div>
              <h3>
                <!-- <span>Some text</span> -->
                <strong>Analytic Reports</strong>
              </h3>
              <div class="tx">
                <p>
                  <strong>Intuitive analytics</strong> for the boards that help
                  with in-company talent insights. Enable people with a
                  measurable career growth. Chart out career trajectories, find
                  talent fitment, and create succession plans for people with a
                  data driven approach.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="rg fx" data-fx>
          <div>
            <div class="cir">
              <div class="circ">
                <div class="circm">
                  <div class="crc">
                    <div>
                      <div class="rnd">
                        <div>
                          <div class="">
                            <i class="i_sie"
                              ><img
                                height="75px"
                                src="@/assets/images/icons/homepage/Skill-Profiles.svg"
                                alt=""
                            /></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="crc">
                    <div>
                      <div class="rnd">
                        <div>
                          <div class="">
                            <i class="i_graphi"
                              ><img
                                height="75px"
                                src="@/assets/images/icons/homepage/Talent Boards.svg"
                                alt=""
                            /></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="crc">
                    <div>
                      <div class="rnd">
                        <div>
                          <div class="">
                            <i class="i_ev"
                              ><img
                                height="75px"
                                src="@/assets/images/icons/homepage/Power Apps.svg"
                                alt=""
                            /></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="crc">
                    <div>
                      <div class="rnd">
                        <div>
                          <div class="">
                            <i class="i_mareting"
                              ><img
                                height="75px"
                                src="@/assets/images/icons/homepage/Analytic Reports.svg"
                                alt=""
                            /></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sp sp-2">
        <div class="eavl1" data-fx>
          <div>
            <div class="ct1">
              <h2>
                <!-- <span class="aa">Stressing out for Placement?</span>
                <span class="ra">Relax, We are here to help!</span> -->
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div id="e">
        <div class="sp sp-5"></div>
        <div class="lgtxc lgtxc-1" data-lg-st="1" data-lg-en="2">
          <div class="ct1">
            <div>
              <h3>
                <span class="stress-txt">Bringing it all together…</span>
                <span class="relax-txt">People, Teams, Tech and Data!</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="lgtxc lgtxc-2" data-lg-st="2" data-lg-en="3">
          <div class="ct2">
            <div>
              <h3>
                <span
                  >Managed Self-Discovery with Personality Feedback for Every
                  Individual</span
                >
              </h3>
            </div>
          </div>
          <div class="ct">
            <div>
              <!-- <h3>
                <strong>But first a reality check</strong>
              </h3> -->
              <div class="txt">
                <p>
                  Build an infographic resume that showcases not just your
                  skills but also your personality. Scientifically created and
                  statistically proven personality models to discover your
                  hidden strengths and blind spots in your competency report.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="lgtxc lgtxc-3" data-lg-st="3" data-lg-en="4">
          <div class="ct2">
            <div>
              <h3>
                <span
                  >Personalized Career Mapping with Career Tools for
                  Organizational Employees</span
                >
              </h3>
            </div>
          </div>
          <div class="ct">
            <div>
              <!-- <h3>
                <strong>The Good News?</strong>
              </h3> -->
              <div class="txt">
                <p>
                  Take personalized career journeys that are curated based on
                  individual preferences and chart out succession plans. Career
                  apps for learning and development, team dynamics, coaching and
                  mentoring, self-discovery and more.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="lgtxc lgtxc-4" data-lg-st="4" data-lg-en="5">
          <div class="ct2">
            <div class="ct5">
              <h3>
                <span>GET BOARDED TO SUCCESS!</span>
              </h3>
            </div>
          </div>
          <div class="ct">
            <div class="ct4">
              <div class="txt success">
                <p>
                  Try it, and if you find it useful, add it to your toolbox. To
                  keep career development simple, we offer a set of apps
                  developed by contributors that leverage other infrastructure
                  wherever possible. Our app marketplace helps you experiment
                  with many ‘new work’ concepts. With a pay-as-you-go model, you
                  can run pilots with small teams before deciding organization
                  wide strategies.
                </p>
              </div>
            </div>
          </div>
        </div>

<!-- for mobile responsive exclusive section start-->
        <div class="d-lg-block responsive">
          <div class="get-boarded pb-20">
            <div>
              <h3>
                <span class="heading-responsive"
                  >Managed Self-Discovery with Personality Feedback for Every
                  Individual</span
                >
              </h3>
            </div>
            <div>
              <p>
                Build an infographic resume that showcases not just your skills
                but also your personality. Scientifically created and
                statistically proven personality models to discover your hidden
                strengths and blind spots in your competency report.
              </p>
            </div>
          </div>
          <div class="get-boarded py-20">
            <div>
              <h3>
                <span class="heading-responsive"
                  >Personalized Career Mapping with Career Tools for
                  Organizational Employees</span
                >
              </h3>
            </div>
            <div>
              <p>
                Take personalized career journeys that are curated based on
                individual preferences and chart out succession plans. Career
                apps for learning and development, team dynamics, coaching and
                mentoring, self-discovery and more.
              </p>
            </div>
          </div>
          <div class="get-boarded py-20">
            <div>
              <h3>
                <span class="heading-responsive">GET BOARDED TO SUCCESS!</span>
              </h3>
            </div>
            <div>
              <p>
                Try it, and if you find it useful, add it to your toolbox. To
                keep career development simple, we offer a set of apps developed
                by contributors that leverage other infrastructure wherever
                possible. Our app marketplace helps you experiment with many
                ‘new work’ concepts. With a pay-as-you-go model, you can run
                pilots with small teams before deciding organization wide
                strategies.
              </p>
            </div>
          </div>
        </div>
<!-- for mobile responsive exclusive section ends-->
      </div>

      <div class="cirbc">
        <div class="ico">
          <svg class="n2" height="100" width="100">
            <circle cx="50" cy="50" r="40" fill="white" />
          </svg>
        </div>
        <svg class="dotted-circle" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="grd-av" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop data-color-c="l" offset="0%" stop-color="white" />
              <stop data-color-c="r" offset="100%" stop-color="white" />
            </linearGradient>
          </defs>
          <circle stroke="url(#grd-av)" cx="50" cy="50" r="48"></circle>
        </svg>
        <svg class="full-circle" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="grd-av1" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop data-color-c="l1" offset="0%" stop-color="#e0e0e0" />
              <stop data-color-c="r1" offset="100%" stop-color="#e0e0e0" />
            </linearGradient>
          </defs>
          <circle stroke="url(#grd-av1)" cx="50" cy="50" r="48"></circle>
        </svg>
        <div class="cirb">
          <div class="cirbr"></div>
        </div>
      </div>

      <div class="sp sp-3"></div>
      <!--<div class="p-10 mb-20">
        <div class="p-20">
          <h2 class="how-we-work">How we work</h2>
        </div>
        <div class="p-20 vx-row d-none lg-block">
          <vs-col class="circl vx-col" vs-lg="7" vs-sm="12" vs-xs="10">
            <svg height="140" width="140" style="position: absolute">
              <circle
                cx="50%"
                cy="50%"
                r="58"
                stroke="orange"
                stroke-width="2"
                fill="#323232"
                fill-opacity=".035"
                stroke-dasharray=".5em"
              />
            </svg>
            <svg height="140" width="140" style="position: relative">
              <circle cx="50%" cy="50%" r="45" fill="orange" />
            </svg>
          </vs-col>
          <vs-col class="circl2 vx-col" vs-lg="4" vs-sm="12" vs-xs="10">
            <svg height="140" width="140" style="position: absolute">
              <circle
                cx="50%"
                cy="50%"
                r="58"
                stroke="orange"
                stroke-width="2"
                fill="#323232"
                fill-opacity=".035"
                stroke-dasharray=".5em"
              />
            </svg>
            <svg height="140" width="140" style="position: relative">
              <circle cx="50%" cy="50%" r="45" fill="orange" />
            </svg>
          </vs-col>
        </div>
         <svg viwBox="0 0 30 10">
          <line x1="0" y1="3" x2="300" y2="3" stroke="orange" stroke-dasharray=".5em" />
        </svg>
        <div class="vx-row pl-20 pe-tr">

          <vs-col class="vx-col pr-20" vs-lg="6" vs-sm="12" vs-xs="10">
            <h5>Personal Evaluation</h5>
            <p>
              These are not rhetorical questions, we'd like you to take a minute
              to think about it before you begin this exercise. The more clear
              you are about your goals, the closer you are to achieving them. <br>
              Want job? WHAT job? Better Role? HOW? Need money? WHY?
            </p>
          </vs-col>
          <vs-col class="vx-col pl-20" vs-lg="6" vs-sm="12" vs-xs="10">
            <h5>The Resume</h5>
            <p>
              Make sure your resume showcases and highlights your employable
              skills; but also your personality. Package well to sell the most
              valuable commodity you have: YOU! <br> That’s why we have designed
              infographic resumes to showcase your personal brand in clear,
              crisp and memorable format.
            </p>
          </vs-col>
        </div>
        <vs-row>
          <div class="p-20" style="justify-content: center;">
            <h3 class="pb-10" style="font-size:26px;font-weight:bold;">Editor Preview</h3>
            <iframe width="768" height="400" src="https://www.youtube.com/embed/1aEim3lc0ec" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </vs-row>
      </div> -->

    </div>
    <Footer />

  </div>
</template>
<script>

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Footer from "../pages/about/about-us-new/Footer";
// import { duration } from 'moment';
gsap.registerPlugin(ScrollTrigger);
export default {
  components: { Footer },
  data() {
    return {
      num: 1,
    };
  },
  mounted() {
    gsap.from("#sv .circ", {
      rotation: 0,
      duration: 1,
      scrollTrigger: {
        trigger: "#sv",
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
    });

    // for rotation

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#sv",
        start: "top top",
        end: "bottom top",
        scrub: true,
        toggleClass: { targets: ".rg", className: "fx1" },
      },
    });

    tl.to("#sv .circm", { rotation: -300, duration: 1 }, "a");

    tl.to("#sv .rnd i", { rotation: 300, duration: 1 }, "a");

    let tll = gsap.timeline({
      scrollTrigger: {
        trigger: "#sv",
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
      },
    });

    tll.from(
      "#sv .rnd i",
      { opacity: 0, scale: 0, duration: 0.25, stagger: 0.25 },
      "a"
    );

    tll.to(
      "#sv .rnd > div > div",

      { width: "100%", height: "100%", duration: 0.25, stagger: 0.25 },
      "a"
    );

    let tlm = gsap.timeline({
      scrollTrigger: {
        trigger: "#sv",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    tlm.to(
      "#sv .rnd > div > div",

      { width: "5%", height: "5%", duration: 0.25, stagger: 0.25 },

      "a"
    );

    tlm.to(
      "#sv .rnd i",
      { opacity: 0, scale: 0, duration: 0.25, stagger: 0.25 },
      "a"
    );

    let tlq = gsap.timeline({
      scrollTrigger: {
        trigger: ".sp-2",
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
      },
    });
    tlq.to("#sv .rg", { paddingLeft: "50%", duration: 0.25 }, "a");

    tlq.to("#sv .rg > div", { y: "0%", duration: 0.25 }, "a");

    tlq.to("#sv .cir", { rotation: -150, x: "-50%", duration: 0.25 }, "a");

    tlq.to(
      "#sv .crc:nth-child(2) > div, #sv .crc:nth-child(4) > div",

      { height: "0%", duration: 0.25 },
      "a"
    );

    tlq.to(
      "#sv .crc:nth-child(1) > div, #sv .crc:nth-child(3) > div",

      { width: "0%", duration: 0.25 },
      "a"
    );

    gsap.to("#sv .crc > div", {
      scale: 0,
      duration: 1,
      scrollTrigger: {
        trigger: ".sp-2",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: ".sp-2",
        start: "top top",
        end: "bottom top",
        scrub: true,
        toggleClass: { targets: ".eavl", className: "fx1" },
      },
    });

    let tla = gsap.timeline({
      scrollTrigger: { trigger: ".sp-2", start: "bottom bottom", scrub: true },
    });
    tla.from(".sp-2 h2", { opacity: 0, duration: 1, x: "50%" }, "a");

    tla.to(
      ".full-circle",

      {
        rotation: 180,
        opacity: 1,
        scale: 4,
        duration: 1,
        strokeDasharray: "302 999",
        strokeWidth: "0.5",
      },
      "a"
    );

    // tlb = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: "#sv",
    //     start: "top top",
    //     once: true,
    //     scrub: true,
    //     toggleClass: { targets: ".cirbc", className: "fx1" },
    //   },
    // });

    let tlb = gsap.timeline({
      scrollTrigger: {
        trigger: ".sp-5",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        toggleClass: { targets: ".cirbc", className: "fx1" },
      },
    });

    tlb.to(
      ".cirbc .cirbr",
      { width: "100%", height: "100%", duration: 1 },
      "a"
    );

    tlb.to("#sv .cir", { scale: 0, opacity: 0, duration: 1 }, "a");

    gsap.utils.toArray(".lgtxc").forEach(function (index) {
      // let n = i+2;

      let tlt = gsap.timeline({
        scrollTrigger: {
          trigger: index,
          start: "top 20%",
          end: "top -30%",
          scrub: true,
        },
      });

      tlt.to(index, { opacity: 0, duration: 1 }, "a");

      // tlt.to(".cirbc i.n" + n, { opacity: 0, scale: 0, duration: 1 }, "a");
    });

    let tlz = gsap.timeline({
      scrollTrigger: {
        trigger: ".lgtxc-2",
        start: "top center",
        end: "top top",
        scrub: true,
      },
    });
    tlz.to(".n2", { opacity: 1, duration: 1 }, "a");

    tlz.to(
      ".full-circle",

      { rotation: -180, opacity: 0, duration: 1, strokeDasharray: "1" },
      "a"
    );

    tlz.to(
      ".dotted-circle",

      { rotation: 180, opacity: 1, duration: 1, strokeDasharray: ".5em" },
      "a"
    );

    let tle = gsap.timeline({
      scrollTrigger: {
        trigger: ".sp-3",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
      },
    });
    // tle.to(
    //   ".cirbc .cirbr",
    //   { backgroundColor: "#f8f8f8", duration: 0.41 },
    //   "a"
    // );

    tle.to(".sp-2", { opacity: 0, duration: 1 }, "a");

    tle.to(".cirbc svg", { opacity: 0, scale: 0 }, "a");

    gsap.utils.toArray("#sv .lgt > div").forEach(function (index) {
      tle.fromTo(
        index,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: index,
            start: "top bottom",
            end: "bottom 80%",
            scrub: true,
          },
        }
      );
    }, "=+1");
  },
};
</script>

<style scoped>
.lgtxc-1 {
  justify-content: center;
}

/*.how-we-work {*/
/*  font-size: 50px;*/
/*  font-weight: bold;*/
/*  text-transform: uppercase;*/
/*  color: #322d2d;*/
/*}*/
.pe-tr h5 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
/*.circl::after {*/
/*  content: "";*/
/*  position: absolute;*/
/*  left: 11vw;*/
/*  width: 72vw;*/
/*  z-index: 0;*/
/*  top: 50%;*/
/*  border: 1px dashed #f29300;*/
/*}*/
/*.ctrcl::before {*/
/*  content: "";*/
/*  position: absolute;*/
/*}*/
/*.circl2::after {*/
/*  content: "";*/
/*  position: absolute;*/
/*  left: 11vw;*/
/*  width: 34vw;*/
/*  z-index: 0;*/
/*  top: 50%;*/
/*  border: 1px dashed #f29300;*/
/*}*/
/*.circle-points img {*/
/*  position: relative;*/
/*}*/

.fx1 {
  position: fixed;
}
.relax-txt {
  font-weight: bold;
  font-size: 56px;
  line-height: 70px;
  letter-spacing: -0.02em;
  text-transform: uppercase;

  color: #ffffff;
}
.ct2 h3 {
  font-weight: bold;
  font-size: 30px;
  line-height: 50px;
  text-align: right;
  text-transform: uppercase;
}
*,
*:after,
*:before {
  -webkit-tap-highlight-color: transparent;
  list-style-position: inside;
  list-style-type: none;
  color: inherit;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  outline: none;
  position: relative;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

#sv .rnd > div > div {
  background: linear-gradient(320deg, #f29300, #f7c881) !important;
}

strong {
  font-weight: 700;
}
.fx {
  margin-top: 0 !important;
}
/*.fxb {*/
/*  margin-top: 0 !important;*/
/*  top: auto !important;*/
/*  bottom: 0 !important;*/
/*}*/
[class^="i_"]:before,
[class*=" i_"]:before {
  font-family: icomoon !important;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
}

.cirbc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}
.cirbc .cirb,
.cirbc .cirbr {
  width: 150vw;
  height: 150vw;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cirbc .cirbr {
  background-color: #16141c;
  width: 0;
  height: 0;
}
.cirbc svg {
  stroke-linecap: round;
  /*stroke-dasharray: 0 999;*/
  opacity: 0;
  width: 100px;
  fill: transparent;
  stroke-width: 2px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}
.cirbc .ico {
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  color: #edf1f3;
}
.cirbc .ico i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.sp {
  height: 100vh;
  /* pointer-events: none; */
}
.sp-3 {
  height: 10vh;
}
#e {
  color: #edf1f3;
  text-align: left;
  padding-top: 50vh;
  /* pointer-events: none; */
}
#e h2 span {
  display: block;
}
#sv {
  min-height: 100vh;
}

/* position: fixed; */
#sv .rg {
  /* pointer-events: none; */
  /* position: fixed; */
  top: 0;
  width: 100%;
  padding-left: 65%;
}
#sv .cir {
  width: 76vh;
  height: 76vh;
  border-radius: 50%;
  top: 12vh;
}
#sv .circ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #cdcccf;
}
#sv .circm {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 50%;
  left: 50%;
}
#sv .rnd {
  width: 1px;
  height: 1px;
  position: absolute;
}
#sv .rnd > div {
  width: calc(120px + 50 * (100vw - 320px) / 1080);
  height: calc(120px + 50 * (100vw - 320px) / 1080);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#sv .rnd > div > div {
  transform-origin: center center;
  box-shadow: 0 1px 3px 1px rgba(99, 0, 243, 0.2);
  width: 5%;
  height: 5%;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#sv .rnd i {
  font-size: calc(50px + 30 * (100vw - 320px) / 1080);
  color: #edf1f3;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#sv .crc {
  position: absolute;
}
#sv .crc > div {
  position: absolute;
  width: 100%;
  height: 100%;
}
#sv .crc:nth-child(1) {
  height: 1px;
  width: 38vh;
  right: 0;
}
#sv .crc:nth-child(1) > div {
  right: 0;
}
#sv .crc:nth-child(1) .rnd {
  left: 0;
}
#sv .crc:nth-child(2) {
  height: 38vh;
  width: 1px;
  bottom: 0;
}
#sv .crc:nth-child(2) > div {
  bottom: 0;
}
#sv .crc:nth-child(2) .rnd {
  top: 0;
}
#sv .crc:nth-child(3) {
  height: 1px;
  width: 38vh;
  left: 0;
}
#sv .crc:nth-child(3) > div {
  left: 0;
}
#sv .crc:nth-child(3) .rnd {
  right: 0;
}
#sv .crc:nth-child(4) {
  height: 38vh;
  width: 1px;
  top: 0;
}
#sv .crc:nth-child(4) > div {
  top: 0;
}
#sv .crc:nth-child(4) .rnd {
  bottom: 0;
}
#sv .lgt {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 50%;
  padding-left: 15%;
}
#sv .lgt h3 {
  font-weight: 200;
  font-size: calc(18px + 10 * (100vw - 320px) / 1080);
  line-height: 1.3;
}
#sv .lgt h3 strong {
  font-weight: 800;
  display: block;
  font-size: 130%;
}
#sv .lgt .tx {
  font-size: calc(13px + 2 * (100vw - 320px) / 1080);
  width: 80%;
  line-height: 1.8;
  margin: calc(20px + 5%) 0;
  color: #666;
  letter-spacing: 0.25px;
}
.sp-5 {
  position: absolute;
  top: 0;
}
.lgtxc {
  text-align: left;
  z-index: 1;
  height: 70vh;
  min-height: 600px;
  max-height: 950px;
  display: flex;
  align-items: center;
}

.stress-txt {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.02em;
  text-transform: uppercase;
}

.lgtxc h3 > * {
  display: block;
}
.lgtxc h3 > strong {
  font-weight: 800;
}
.lgtxc .txt {
  font-size: calc(13px + 2 * (100vw - 320px) / 1080);
  width: 100%;
  font-weight: 200;
  line-height: 1.8;
  margin: calc(15px + 2%) auto 0;
}
.lgtxc .txt strong {
  font-weight: 800;
}

.responsive {
  display: none;
  text-align: center;
  color: #2c2c2c;
  text-transform: uppercase;
}
.responsive p {
  font-size: calc(13px + 2 * (100vw - 320px) / 1080);
  width: 100%;
  font-weight: 200;
  line-height: 1.8;
  margin: calc(15px + 2%) auto 0;
}
.responsive h3 {
  font-weight: bold;
  font-size: 30px;
  line-height: 50px;
  text-transform: uppercase;
}

@media screen and (max-width: 1250px) {
  #sv .rg {
    padding-left: 75%;
  }
  #sv .lgt {
    padding-right: 35%;
  }
}
@media screen and (min-width: 950px) {
  .success {
    width: 28vw;
    left: 14vw !important;
  }
  .ct5 {
    left: 20vw !important;
    width: 20vw !important;
  }
  .lgtxc .ct > div {
    left: 19vw;
    /* width: calc(71% - 100px); */
    width: 26vw;
  }
  .ct {
    width: 70vw;
    margin: auto;
  }
  .lgtxc .ct1 > div {
    text-align: center;
  }

  .lgtxc .ct2 > div {
    width: 40vw;
  }
  .lgtxc .txt {
    color: #edf1f3;
  }
}
@media screen and (max-width: 950px) {
  .lgtxc,
  .relax-txt {
    color: #2c2c2c;
  }
}
@media screen and (min-width: 901px) {
  #sv .rg > div {
    transform: none !important;
  }
}
@media screen and (max-width: 950px) {
  html:not(.horiz) #app {
    overflow: visible;
  }
  #sv .rg {
    padding-left: 0 !important;
    left: 0;
  }
  #sv .rg > div {
    transform: translateY(-70%) rotate(-90deg);
    transform-origin: center center;
  }
  #sv .rg .cir {
    top: 0;
    width: 100vw;
    height: 100vw;
  }
  #sv .rg .rnd {
    transform: rotate(90deg);
  }
  #sv .lgt {
    padding: 30vw 0 0 !important;
    text-align: center;
  }
  #sv .lgt .tx {
    width: 100%;
    padding: 0 calc(20px + 5%);
    margin: calc(25px + 15 * (100vw - 320px) / 1080) 0;
  }
  #sv .crc:nth-child(1),
  #sv .crc:nth-child(3) {
    width: 50vw;
  }
  #sv .crc:nth-child(2),
  #sv .crc:nth-child(4) {
    height: 50vw;
  }
  #sv .lgt h3 strong {
    font-weight: 800;
    display: block;
    font-size: 130%;
  }
  /*.eavl {*/
  /*  text-align: center;*/
  /*  margin-top: 0 !important;*/
  /*  position: absolute;*/
  /*  align-items: flex-end;*/
  /*}*/
  .eavl h2 {
    display: none;
    transform: none !important;
    opacity: 1 !important;
    width: 100%;
    top: 100vh;
    left: 0;
  }

  .eavl .ct {
    width: 100%;
    text-align: center;
  }
  .lgtxc .ct > div {
    width: 100%;
    left: 0;
    text-align: center;
  }
  .cirbc svg,
  .cirbc .ico {
    top: 30%;
  }
  .cirbc {
    display: none;
  }
  .circ {
    display: none;
  }
  .sp {
    display: none;
  }
}
@media screen and (max-width: 950px) {
  .responsive {
    display: block;
    padding: 65px;
  }
  .lgtxc-2,
  .lgtxc-3,
  .lgtxc-4 {
    display: none;
  }
}
@media screen and (max-width: 589px) {
.responsive {
  padding: 35px;
}
  .heading-responsive {
    font-size: 24px;
  }
  .relax-txt {
    font-size: 36px;
  }
  .ct1 {
    text-align: center;
  }
  .get-boarded p {
    text-align: justify;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 180%;
    color: rgba(74, 74, 74, 0.86);
  }
}
</style>
